export const businessHours = {
    days: 'Mon-Sun',
    open: '10 AM',
    close: '6 PM',
    timezone: 'PT',
    // Machine-readable counterparts
    tzName: 'America/Los_Angeles',
    activeDays: [0, 1, 2, 3, 4, 5, 6], // Sun=0, Wed=3, etc
    startHour: 10,
    endHour: 18,
}
